import React from 'react';
import PropTypes from 'prop-types';
import {INLINES, BLOCKS} from '@contentful/rich-text-types';
import {renderRichText} from 'gatsby-source-contentful/rich-text';
import {embeddedEntry, assetHyperlink, headingBlock} from './richTextRenderers';
import LocalizedLink from '../LocalizedLink/LocalizedLink';

const RichText = ({body}) => {
    const options = {
        renderNode: {
            [INLINES.ENTRY_HYPERLINK]: (entry, children) => {
                if (!entry.data.target || !entry.data.target.slug) {
                    // An entry hyperlink pointing to a non-existing document (unpublished, removed, ...)
                    // The className could be useful to identify this situation and notify editors
                    const missingHyperlinkText = entry.content[0].value;
                    return (
                        <span className="missing-hyperlink">
                            {missingHyperlinkText}
                        </span>
                    );
                }

                return (
                    <LocalizedLink
                        locale={entry.data.target.node_locale}
                        slug={entry.data.target.slug}
                    >
                        {children}
                    </LocalizedLink>
                );
            },
            [INLINES.ASSET_HYPERLINK]: assetHyperlink,
            [BLOCKS.EMBEDDED_ENTRY]: embeddedEntry,
            [BLOCKS.HEADING_2]: headingBlock,
            [BLOCKS.HEADING_3]: headingBlock,
            [BLOCKS.HEADING_4]: headingBlock,
            [BLOCKS.HEADING_5]: headingBlock,
            [BLOCKS.HEADING_6]: headingBlock,
        },
        // necessary to render rich text new line character as a <br /> tag
        renderText: (text) => {
            return text.split('\n').reduce((children, textSegment, index) => {
                return [
                    ...children,
                    index > 0 && <br key={index} />,
                    textSegment,
                ];
            }, []);
        },
    };
    return renderRichText(body, options);
};

RichText.propTypes = {
    body: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default RichText;
